import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Footer} from '../../components';
import {redirectToTermsAccept} from '../../ducks/Navigate';
import {RouteKeys} from '../../constants';
import {StringService} from '../../services';

import './styles.scss';

class SignatureExample extends Component {
  componentDidMount() {
    document.title = StringService.formatTitle(
      RouteKeys.SignatureExample.title,
    );
  }

  render() {
    return (
      <div className="div-signature-example">
        <div className="content">
          <div className="info ">
            <p className="title"> E por último! </p>
          </div>

          <div className="info">
            <p className="info-content">
              Precisamos da sua <strong>assinatura.</strong>
            </p>
          </div>
          <div>&nbsp;</div>
          <div className="info">
            <img className="img" src="/img/assinatura.svg" alt="Assinatura" />
          </div>

          <div className="info">
            <p className="info-content-small">
              Você receberá um <br />
              <strong>link por e-mail*</strong> e um{' '}
              <strong>código por SMS. </strong>
              <br /> Click no link para colocar sua
              <br /> assinatura digital e finalizar a proposta.
            </p>
          </div>

          <div className="info">
            <p className="info-content-smallest">
              *Verifique sua caixa de spam.
            </p>
          </div>
        </div>

        <Footer
          styleBackgroundColorBack="#005fa1"
          styleColorTextBack="white"
          nextHandle={() => {}}
          backHandle={() => {
            this.props.redirectToTermsAccept();
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = ({customer}) => {
  const {chave, dadosPessoais} = customer;
  return {chave, dadosPessoais};
};

export default connect(mapStateToProps, {redirectToTermsAccept})(
  SignatureExample,
);
